import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function purchasedTotalReducer(
  state = initialState.purchasedTotal,
  action
) {
  switch (action.type) {
    case types.LOADED_TOTAL_PURCHASED:
      return action.purchasedTotal;
    default:
      return state;
  }
}
